import React, { useCallback } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// import { device } from "../../../utils/media-queries";
import { BowButton } from "../bow-button";

// import button from "./button.png";

// const Image = styled.img`
//   cursor: pointer;

//   @media ${device.mobileS} {
//     width: 349px;
//     height: 96px;
//   }

//   @media ${device.laptopL} {
//     width: 436px;
//     height: 115px;
//   }
// `;

const StyledBowButton = styled(BowButton)`
  margin-top: 25px;
`;

export const GetMySantaLetterButton: React.FC = () => {
  const history = useHistory();

  const handleClick = useCallback((): void => history.push("/santa-letter"), [history]);

  // return <Image src={button} onClick={handleClick} />;
  return (
    <StyledBowButton size={430} onClick={handleClick}>
      Get a Digital Santa Letter
    </StyledBowButton>
  );
};
